import { IFareBreakdown, IItinerary } from "@thekilroygroup/shared-ui";

export const getIsStudent = (itinerary: IItinerary) => {
  if (
    itinerary.fareBreakdowns.find(
      (breakdown: IFareBreakdown) => breakdown.passengerType === "STU",
    )
  ) {
    return true;
  }
  return false;
};

export const getIsYouth = (itinerary: IItinerary) => {
  if (
    itinerary.fareBreakdowns.find(
      (breakdown: IFareBreakdown) => breakdown.passengerType === "YTH",
    )
  ) {
    return true;
  }
  return false;
};

export const hasStudentOrYouth = (itinerary: IItinerary) => {
  return getIsStudent(itinerary) || getIsYouth(itinerary);
};
